<template>
  <div class="rb-gia-certificate">
    <icon-gia />
    <span v-if="label && diamond">
      <template v-if="diamond && diamond.cert_url">
        <a
          :href="diamond.cert_url || '#'"
          target="_blank"
          :id="`gia-certificate-${diamond.cert_num}`"
          @click="notifyGia"
          >GIA {{ mode === "certified" ? "Certified" : diamond.cert_num }}</a
        >
      </template>
      <template v-else>
        GIA {{ mode === "certified" ? "Certified" : diamond.cert_num }}
      </template>
    </span>
  </div>
</template>
<script>
/**
 * Displays Gia Information
 *
 * @implements
 * TrackMixin
 *
 * @props
 * label: String
 * mode: String
 * diamond: Object
 */
import IconGia from "@/components/icons/IconGia";
import TrackMixin from "@/mixins/TrackMixin";
export default {
  mixins: [TrackMixin],
  components: {
    IconGia,
  },
  props: {
    label: {
      type: Boolean,
      default: true,
    },
    mode: {
      type: String,
      default: "certified",
    },
    diamond: {
      type: Object,
    },
  },
  methods: {
    notifyGia: function (event) {
      this.trackEvent(
        this.formatTracking(this.getTrackId(event), this.TRACK_CLICK),
        this.getTrackId(event)
      );
    },
  },
};
</script>
